import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { YdsButtonComponent, YdsModalComponent } from '../../yds-angular';
import { ConfirmDialogService } from './confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  imports: [YdsModalComponent, YdsButtonComponent, TranslateModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  readonly dialogService = inject(ConfirmDialogService);

  cancel(): void {
    this.dialogService.resolve(false);
  }

  confirm(): void {
    this.dialogService.resolve(true);
  }

  onDismiss(): void {
    this.dialogService.resolve(false);
  }
}
